import type { TFunction } from 'i18next';

export const MEMBER_MARITAL_FILTER_VALUES = [
  'single',
  'married',
  'separated',
  'divorced',
  'widowed',
  'other',
] as const;

export const MEMBER_RECEPTION_FILTER_VALUES = [
  'profession',
  'confirmation',
  'transfer',
  'reaffirmation',
  'restoration',
  'birth',
  'other',
] as const;

export const maritalStatusFilterOptions = (t: TFunction<'people'>) =>
  MEMBER_MARITAL_FILTER_VALUES.map((value) => ({
    value,
    label: t(`members.marital.${value}`),
  }));

export const receptionMethodFilterOptions = (t: TFunction<'people'>) =>
  MEMBER_RECEPTION_FILTER_VALUES.map((value) => ({
    value,
    label: t(`members.reception.${value}`),
  }));
